import * as Sentry from "@sentry/nextjs";

Sentry.init({
    dsn: "https://0cff0c152966fc8f3508f1fa727bc263@o4508068756914176.ingest.us.sentry.io/4511082836787200",

    // Capture 100% of transactions for performance monitoring
    tracesSampleRate: 1.0,

    // Capture 100% of session replays on errors, 10% baseline
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
    ],

    // Filter out noisy errors
    ignoreErrors: [
        "ResizeObserver loop",
        "ResizeObserver loop completed with undelivered notifications",
    ],
});
